import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-one',
  templateUrl: './review-one.component.html',
  styleUrls: ['./review-one.component.css']
})
export class ReviewOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
